module.exports = __webpack_public_path__ + "img/9-tunnel_v8e_loading.2287966a.jpg";